'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var Refund = module.exports = SoaModel.extend();

var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var Backbone = require('dibs-backbone');

var EcomCharges = require('bunsen/collections/ecomm/EcomCharges');
var Notes = require('bunsen/collections/Notes');

_.extend(Refund, {
    REASON_DEALER_CANCEL_BEFORE_SHIP : "DEALER_CANCEL_BEFORE_SHIP",
    REASON_CUSTOMER_CANCEL_BEFORE_SHIP_IN_POLICY : "CUSTOMER_CANCEL_BEFORE_SHIP_IN_POLICY",
    REASON_CUSTOMER_CANCEL_BEFORE_SHIP_OUTSIDE_POLICY : "CUSTOMER_CANCEL_BEFORE_SHIP_OUTSIDE_POLICY",
    REASON_ITEM_NOT_RECEIVED : "ITEM_NOT_RECEIVED",
    REASON_ITEM_ARRIVED_DAMAGED : "ITEM_ARRIVED_DAMAGED",
    REASON_ITEM_NOT_AS_DESCRIBED : "ITEM_NOT_AS_DESCRIBED",
    REASON_ITEM_NO_LONGER_DESIRED_IN_POLICY : "ITEM_NO_LONGER_DESIRED_IN_POLICY",
    REASON_ITEM_NO_LONGER_DESIRED_OUTSIDE_POLICY : "ITEM_NO_LONGER_DESIRED_OUTSIDE_POLICY",
    REASON_ITEM_AND_SHIPPING_COST_REDUCTION : "ITEM_AND_SHIPPING_COST_REDUCTION",
    REASON_ITEM_COST_REDUCTION : "ITEM_COST_REDUCTION",
    REASON_SHIPPING_COST_REDUCTION : "SHIPPING_COST_REDUCTION",
    REASON_OTHER : "OTHER",

    STATE_NEW : "NEW"
});

_.extend(Refund.prototype, {
    url: function () {
        return endpoints.refund(this.id);
    },
    relations : SoaModel.createRelations([
        {
            key : 'charges',
            collectionType : EcomCharges,
            type : Backbone.Many
        },
        {
            key : 'notes',
            collectionType : Notes,
            type : Backbone.Many
        }
    ])
});




//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/Refund.js
// module id = 177
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56